import React, { Suspense, useRef } from 'react'
import { Canvas, extend, useFrame } from '@react-three/fiber'
import { OrbitControls, Stage, Loader, Environment } from '@react-three/drei'
import { easing, geometry } from 'maath'
import ModelOne from './ModelOne'
import ModelTwo from './ModelTwo'
import ModelThre from './ModelThre'
import useApp from './hook/useApp'
import { Effects } from './Effects'

extend(geometry)

export default function App() {
  const { open, number, camera, _clickClose } = useApp()

  const clickClose = (w) => {
    _clickClose()
  }

  return (
    <>
      <div className="c-tank">
        <div className="c-tank__bg">
          <img src="https://tanki-media-content.tanki.su/tanki-media/images/battle-pass-12/bg.png" alt="" style={open ? { opacity: .6 } : { opacity: 1 }} />
        </div>
        <div className="c-title">3D-СТИЛИ СЕЗОНА</div>
        {open ? (
          <div className="c-overlay">
            <div className="c-overlay__body">
              <div
                className="c-overlay__close"
                onClick={() => {
                  clickClose()
                }}>
                <img src="https://tanki-media-content.tanki.su/tanki-media/3d/battle-pass-byzantium/public/close.svg" alt="" />
              </div>
              <div className="c-wrap">
                {number === 'one' ? (
                  <>
                    <div className="c-overlay__title">СТИЛЬ «ЛЕОНА» ДЛЯ BAT CHATILLON 25T</div>
                    <div className="c-overlay__text">
                      <p>Разместили нас в местной гостинице, я даже удивилась — тут почти как дома уютно. Так и не скажешь сразу, что за тысячи километров от Парижа. Любят гостей в Сибири, ведут себя вполне искренне. Честно говоря, до сих пор не знаю, что тут выяснять. По первым впечатлениям — задание для школьного теста, не сложнее. Всё же и так понятно: русский пытается казаться своим, таким открытым и бесхитростным. Похоже, что просто играет роль назначенного представителя советской делегации. Он — принимающая сторона, ему тут явно скучно, для него это рутина. По крайней мере, он именно так себя ставит. Пфф, да у него на лице написано, что он тут явно не случайный человек. Мы таких в SDECE по косточкам разбирали, неинтересно. Китаец... С ним пока сложно, он вообще на контакт не идёт. Пока что. Ещё есть время. А что до нашего танка... Вилланель, родная, ты же его видела сама. И как мы с тобой обе не ослепли от такой красоты? Элегантный холёный француз, за которого не стыдно в кое-то веки. И нет, в этот раз я не иронизирую. Передай нашим из «топаза», что дело пошло. Похоже, моё приключение тут только начинается.</p>
                    </div>
                  </>
                ) : (
                  ''
                )}

                {number === 'two' ? (
                  <>
                    <div className="c-overlay__title">СТИЛЬ «АЛЬТАИР-4» ДЛЯ K-91</div>
                    <div className="c-overlay__text">
                      <p>Кругом приятные сюрпризы и удачные стечения обстоятельств. Тут сперва сорока на хвосте принесла, что мы ничего не успеваем, что какие-то трубки ещё не готовы, не протянуты. Потом выясняется, что для протяжки всех магистралей чуть ли не половину танка разобрать надо. Но нет, ты ж посмотри, пока машину на платформе до Новосибирска тянули, наши механики прямо на ходу всё в порядок привели. В Тюмени ещё застряли, но и это на руку оказалось — всё успели, блеск навели, ребята ещё и отоспались под брезентом. Надо по возвращении на них благодарственное письмо составить. Так это полдела ещё. Уже в Новосибирске, когда я поезд встретил, к нам кран подогнали, чтобы танк с платформы снять, а он возьми — и сам с неё съедь. Ну что, мол, такого? А у встречающих глаза как блюдца, говорят, что уж точно не ожидали, что заявленный экспонат на ходу будет, мол, такого не было раньше. Я было хотел сказать, что у нас и орудие ещё стреляет, но одёрнули меня. Ну и вишенка на торте: кто-то из инженеров предложил к названию четвёрку добавить. Уже к вокзалу подъезжали. Говорит, пусть, мол, думают, что у нас ещё как минимум три экземпляра или прототипа есть. Правильно, это не штучная сборка для выставок. У нас в СССР только крупные серии! Надо было всё-таки про орудие сказать. Или про микрореактор атомный, зря что ли ставили?</p>
                    </div>
                  </>
                ) : (
                  ''
                )}

                {number === 'thre' ? (
                  <>
                    <div className="c-overlay__title">СТИЛЬ «ЗВЁЗДНЫЙ ЛОТОС» ДЛЯ WZ-132-1</div>
                    <div className="c-overlay__text">
                      <p>Отличный парень этот Кан Тао, дружелюбный. Простой, как лом. Улыбается постоянно, что-то лепечет на своём, жестикулирует активно. Меня как схватил за пуговицу, так и давай водить вокруг своего танка, что-то видать интересное про него рассказывал. Смеётся, довольный такой. Типичный шпик, видали мы таких. А что рассказывал-то? Вряд ли что-то по делу, голову дурил мне, не иначе. Ну а я вежливо кивал в ответ, пытался восхищение изобразить, всё одно не понимаю я его языка. А по-английски он плохо понимает. Ну, или вид делает. Потом потащил меня к Альтаиру, всё своим фотоаппаратом щёлкал, вопросы задавал. Наверное. Ну тут я как учили: общие фразы, улыбка, обещания показать устройство "зеро эмишен пауэртрейн" (знать бы самому, что это). Всё твердил мне, "СССР — гуд!". Конечно, гуд, а ты думал, ты же не на сельхозвыставку приехал. Тут только лучшие изделия... Но вроде отстал, когда плёнку нащёлкал свою. Фонарик даже подарил. На память. Тяжеловатый фонарик, как литой всё равно что... И поди знай, как его разобрать. А надо бы: многие вещи совсем не то, чем кажутся.</p>
                    </div>
                  </>
                ) : (
                  ''
                )}
              </div>
            </div>
          </div>
        ) : (
          ''
        )}

        <Canvas
          shadows="true"
          camera={{
            position: camera,
            isPerspectiveCamera: true,
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
            zoom: 1.6,
            fov: 50
          }}>
          <Suspense fallback={null}>
            <Backdrop />
          </Suspense>
          <Effects />
          {open ? <OrbitControls enableZoom={false} enablePan={false} maxPolarAngle={Math.PI / 2.1} makeDefault /> : <OrbitControls enableZoom={false} enablePan={false} minPolarAngle={Math.PI / 2.1} maxPolarAngle={Math.PI / 2.1} makeDefault />}
        </Canvas>
        <Loader />
      </div>
    </>
  )
}

function Backdrop() {
  const group = useRef()

  const { scale, shadows, rotation } = useApp()

  useFrame((state, delta) => {
    // easing.dampE(group.current.rotation, [0, -state.pointer.x * (Math.PI / 30), 0], 1.5, delta)

  })

  return (
    <group ref={group} rotation={rotation}>
      <spotLight angle={1} position={[-80, 200, -100]} intensity={0.1} castShadow />
      <ambientLight intensity={.30} />
      <Stage intensity={0.15} shadows={shadows} environment={null}>
        <Environment files="https://tanki-media-content.tanki.su/tanki-media/3d/battle-pass-knights-move/potsdamer_platz_1k.hdr" />
        <ModelOne scale={scale.one} />
        <ModelTwo scale={scale.two} />
        <ModelThre scale={scale.thre} />
      </Stage>
    </group>
  )
}
